module.exports = {
  development: {
    apiUrl: "http://127.0.0.1:3000",
    wsUrl: "http://127.0.0.1:3000/cable"
  },
  production: {
    apiUrl: "https://api.nitpoint.com",
    wsUrl: "wss://api.nitpoint.com/cable"
  }
};
